import { lazy } from 'react'

const BobWorldlineIndex = lazy(() => import('../../views/bob-worldline'))
const PaymentError = lazy(() => import('../../views/bob-worldline/PaymentError'))
const PaymentFailure = lazy(() => import('../../views/bob-worldline/PaymentFailure'))
const PaymentProcess = lazy(() => import('../../views/bob-worldline/PaymentProcess'))
const PaymentSuccess = lazy(() => import('../../views/bob-worldline/PaymentSuccess'))
const PaymentCancelled = lazy(() => import('../../views/bob-worldline/PaymentCancelled'))

const BobWorldlineRoutes = [
  {
    element: <BobWorldlineIndex />,
    path: '/bob-worldline',
    meta: {
      layout: 'horizontal',
      publicRoute: true,
      restricted: false
    }
  },
  {
    element: <PaymentError />,
    path: '/bob-worldline/error',
    meta: {
      layout: 'horizontal',
      publicRoute: true,
      restricted: false
    }
  },
  {
    element: <PaymentFailure />,
    path: '/bob-worldline/failure',
    meta: {
      layout: 'horizontal',
      publicRoute: true,
      restricted: false
    }
  },
  {
    element: <PaymentFailure />,
    path: '/bob-worldline/failure/:transactionId',
    meta: {
      layout: 'horizontal',
      publicRoute: true,
      restricted: false
    }
  },
  {
    element: <PaymentCancelled />,
    path: '/bob-worldline/cancelled',
    meta: {
      layout: 'horizontal',
      publicRoute: true,
      restricted: false
    }
  },
  {
    element: <PaymentCancelled />,
    path: '/bob-worldline/cancelled/:transactionId',
    meta: {
      layout: 'horizontal',
      publicRoute: true,
      restricted: false
    }
  },
  {
    element: <PaymentProcess />,
    path: '/bob-worldline/process',
    meta: {
      layout: 'horizontal',
      publicRoute: true,
      restricted: false
    }
  },
  {
    element: <PaymentProcess />,
    path: '/bob-worldline/process/:transactionId',
    meta: {
      layout: 'horizontal',
      publicRoute: true,
      restricted: false
    }
  },
  {
    element: <PaymentSuccess />,
    path: '/bob-worldline/success',
    meta: {
      layout: 'horizontal',
      publicRoute: true,
      restricted: false
    }
  },
  {
    element: <PaymentSuccess />,
    path: '/bob-worldline/success/:transactionId',
    meta: {
      layout: 'horizontal',
      publicRoute: true,
      restricted: false
    }
  }
]

export default BobWorldlineRoutes
